import { useMemo } from "react";
import { useLanguage } from "../context/LanguageContext";
import { getInstitutionalOrganization } from "../data/organizations";
import { mapInstitutionalOrganizationToPage } from "../presentation/organizations/institutionalPage.mapper";
import type { InstitutionalPageData } from "../presentation/organizations/institutionalPage.types";

export const useInstitutionalOrganization = (): InstitutionalPageData | undefined => {
  const { language } = useLanguage();

  return useMemo(() => {
    const organization = getInstitutionalOrganization();
    return organization
      ? mapInstitutionalOrganizationToPage(organization, language)
      : undefined;
  }, [language]);
};
